import { Box, Button } from "@chakra-ui/react";
import { useSession } from "context/SessionContext";
import { useQuestionnaire } from "hooks/useQuestionnaire";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Questions, Section } from "types";
import Checkbox from "../Checkbox/Checkbox";
import Heading from "../Heading/Heading";
import SectionComponent from "../SectionComponent/SectionComponent";
import { initializeDefaultValues, resetFormValues } from 'utils/formUtils';
import { useTabContext } from 'context/TabContext';

interface DynamicSubTab {
  question: Questions;
  activityFilter: string;
  parentTab: number;
  afterSubmit: (data?: any) => void;
  onTabReset: () => void;
  onSubmitFormHandle: (event: any, question: any, handleNext: any, handleSubmit: any, setError: any, message?: string) => void;
  setSubTabQuestionsHandle: (section: Section[]) => void;
}

export const DynamicSubTab: React.FC<DynamicSubTab> = ({ question, activityFilter, afterSubmit, parentTab, onTabReset, onSubmitFormHandle , setSubTabQuestionsHandle }) => {
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm();
  const { saveQuestionnaire } = useSession();

  const { validateStep, validateSubQuestion, editValues, validateInputs } = useQuestionnaire();
  const { enabledTabs } = useTabContext();
  const [section, setSection] = useState<Section[]>([]);
  
  useEffect(() => {
    setSection(question.sections);
  }, [parentTab]);

  const handleNext = async () => {
    const values = getValues();
    validateStep(values);

    const answersArray = editValues(getValues);

    const answerData = {
      questionnaireId: section[0].code,
      activityCode: activityFilter,
      answers: [...answersArray],
    };

    const newData = saveQuestionnaire(answerData);
    
    afterSubmit(newData);
  };

  useEffect(() => {
    if (!enabledTabs.includes(parentTab)) {
      resetFormValues(section, setValue, reset, initializeDefaultValues(section));
      onTabReset()
    }
  }, [enabledTabs]);

  function onSubmitHandle(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setSubTabQuestionsHandle(section);

    onSubmitFormHandle(event, section, handleNext, handleSubmit, setError);

  }

  return (
    
    (section && section.length > 0 ?
    <Box>
      <Box>
        <Heading title={section[0].title} />
      </Box>
      <Box>
       <form
          onSubmit={onSubmitHandle}
        >
          {section.map(sectionList => (
            <SectionComponent
              key={sectionList.code}
              sectionList={sectionList}
              control={control}
              validateInputs={validateInputs}
              getValues={getValues}
              validateSubQuestion={validateSubQuestion}
              errors={errors}
              handleDataChange={setSection}
              dataListChange={section}
            />
          ))}

          <Checkbox
            name={`confirmInfo6`}
            control={control}
            label="Confirmo a Informação"
            rules={{ required: 'Campo de preenchimento obrigatório' }}
            error={errors?.[`confirmInfo6`]}
          />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              variant={'primary'}
              type="submit"
            >
              <span>Continuar</span>
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
    : null)
    )
}